import { useMutation } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

import { baseAPI } from '~shared/api/base-api';
import { toast } from 'sonner';
import Axios from 'axios';
import type { ErrorWithMessage } from '~shared/api/types/error-with-message';

export const verifyForgotPasswordAPI = async (email: string, locationId: string, otp: number, newPassword: string) => {
  const response = await baseAPI.post<unknown>(`/users/verify-forgot-password`, {
    email: email,
    locationId: locationId,
    otp: otp,
    newPassword: newPassword,
  });
  return response.data;
};

export const useVerifyForgotPassword = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: ({email, locationId, otp, newPassword}: {email: string, locationId: string, otp: number, newPassword: string}) => verifyForgotPasswordAPI(email, locationId, otp, newPassword),
    onSuccess: (_data, { locationId}) => {
        toast.success('Password reset successfully');
        void navigate({ to: '/login', search: { id: locationId } });
    },
    onError: (error, { locationId }) => {
      let errorMessage = 'Failed to verify OTP';
      if (Axios.isAxiosError(error)) {
        errorMessage = (error.response?.data as ErrorWithMessage).error?.message ?? 'Failed to verify OTP';
        errorMessage = errorMessage.includes('Studio not found') ? 'Please confirm your URL and try again.' : errorMessage;

        if (error.response?.status === 400) {
          toast.error(errorMessage);
          return;
        }
      }
      toast.error(errorMessage);
      void navigate({ to: '/login', search: { id: locationId } });
    },
  });
};

